import Vue from 'vue'
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
 
Vue.use(LottieAnimation);
Vue.component('LottieAnimation', LottieAnimation);